import type { Frame } from '@photobooth/types';

interface FrameCardProps {
  frame: Frame;
  categoryName?: string;
  onDelete: (frameId: string) => void;
}

export function FrameCard({ frame, categoryName, onDelete }: FrameCardProps) {
  const handleDelete = () => {
    if (confirm(`Are you sure you want to delete "${frame.name}"?`)) {
      onDelete(frame.frameId);
    }
  };

  return (
    <div className="bg-surface rounded-lg shadow overflow-hidden hover:shadow-lg transition-shadow">
      <div className="aspect-square bg-gray-100 relative">
        <img
          src={frame.thumbnailUrl || frame.imageUrl}
          alt={frame.name}
          className="w-full h-full object-cover"
        />
        {!frame.isActive && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <span className="text-white font-medium">Inactive</span>
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-bold text-text mb-1">{frame.name}</h3>
        <div className="flex items-center justify-between text-sm text-text-muted mb-2">
          <span>{categoryName || 'No category'}</span>
          <span className="px-2 py-0.5 bg-gray-100 rounded text-xs">
            {frame.paperType === 'collage_4x6' ? '4x6' : 'Strip'}
          </span>
        </div>
        <button
          onClick={handleDelete}
          className="w-full text-red-600 hover:text-red-700 text-sm font-medium"
        >
          Delete
        </button>
      </div>
    </div>
  );
}
